import { Injectable } from '@angular/core';
import { Departamento } from 'src/app/models/api/comercial/departamento';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiDepartamentoService {
  private baseUrl = 'Departamento';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Departamento[]>('');
  }
}
